<template>
  <a-layout-header
    v-if="emailToken"
    class="flex items-center justify-between"
    :style="{ height: '48px', padding: '0 16px', background: 'white' }"
  >
    <div class="pl-2.5 flex items-center w-full">
      <span
        class="text-base font-bold cursor-pointer inline-block truncate w-[calc(100vw-6rem)] md:w-[calc(280px-0.625rem)]"
        @click="
          () => {
            router.push('/login');
          }
        "
      >
        <Logo />
      </span>
    </div>
  </a-layout-header>

  <div :class="{ 'user-info-container': emailToken }" v-if="hasShowForm">
    <a-form ref="formRef" :model="formData" :rules="rules">
      <div v-if="emailToken" class="text-base register-title ml-4 font-bold">
        <span>{{ $t('account_information_register') }}</span>
      </div>
      <div v-if="emailToken" class="border-t border-gray-300 my-4"></div>
      <div class="box-item">
        <div class="box-inner">
          <InputSlot
            :label="$t('account_name')"
            inputId="accountName"
            :inputSpan="{ xs: 24, sm: 14, md: 14, lg: 14, xl: 12, xxl: 8 }"
            :required="requiredData.accountName"
          >
            <a-form-item ref="accountName" name="accountName">
              <a-input
                id="accountName"
                ref="accountNameRef"
                v-model:value="formData.accountName"
                :data-jwnet-value="formData.accountName"
                maxlength="16"
              ></a-input>
            </a-form-item>
          </InputSlot>
        </div>
      </div>
      <div class="box-item">
        <div class="box-inner">
          <div class="box-head">
            <a-row :gutter="{ xs: 8, sm: 16 }">
              <a-col :xs="10" :sm="2">
                <div class="btnLabel text-center">{{ $t('company_infomation') }}</div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="box-item border-blue">
        <div class="box-inner">
          <InputSlot
            :label="$t('company_name')"
            inputId="file"
            :inputSpan="{ xs: 24, sm: 14, md: 14, lg: 14, xl: 12, xxl: 8 }"
            :required="requiredData.companyName"
          >
            <a-form-item ref="companyName" name="companyName">
              <a-input
                id="companyName"
                v-model:value="formData.companyName"
                :data-jwnet-value="formData.companyName"
                maxlength="32"
              ></a-input>
            </a-form-item>
          </InputSlot>
          <a-row :gutter="{ xs: 8, sm: 16 }">
            <a-col :xs="17" :sm="16" :md="12" :lg="12" :xl="8" :xxl="6">
              <InputSlot
                :label="$t('postal_code')"
                inputId="file"
                :labelSpan="{ xs: emailToken ? 15 : 13, sm: 9, md: 6, lg: 8, xl: 9, xxl: 8 }"
                :inputSpan="{ xs: emailToken ? 9 : 11, sm: 12, md: 18, lg: 16, xl: 15, xxl: 16 }"
                :required="requiredData.companyPostalCode"
              >
                <a-form-item ref="postalCode" name="companyPostalCode">
                  <a-input
                    id="companyPostalCode"
                    v-model:value="formData.companyPostalCode"
                    data-jwnet-exempt
                    maxlength="8"
                    @input="formatPostalCode($event, 'company')"
                    @change="handleChangePostalCode('company')"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
            <a-col :xs="7" :sm="8" :md="12" :lg="12" :xl="8" :xxl="6">
              <a-button
                @click="getAddress('company')"
                size="small"
                class="btn-search-adr"
                type="primary"
                :disabled="
                  (formData.companyPostalCode && formData.companyPostalCode.length < 8) ||
                  !formData.companyPostalCode
                "
              >
                {{ $t('address_search') }}
              </a-button>
            </a-col>
          </a-row>
          <InputSlot
            :label="$t('address')"
            inputId="address"
            :inputSpan="{ xs: 24, sm: 18, md: 21, lg: 20, xl: 21, xxl: 22 }"
            :required="requiredData.companyAddress"
          >
            <a-form-item ref="address" name="companyAddress">
              <a-input
                id="companyAddress"
                v-model:value="formData.companyAddress"
                :data-jwnet-value="formData.companyAddress"
                maxlength="254"
                :disabled="isDisabledCompanyFields"
              ></a-input>
            </a-form-item>
          </InputSlot>
          <a-row :gutter="{ xs: 8, sm: 16 }">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="8">
              <InputSlot
                :label="$t('telephone')"
                inputId="telephone"
                :labelSpan="{ xs: 24, sm: 6, md: 6, lg: 8, xl: 6, xxl: 6 }"
                :inputSpan="{ xs: 24, sm: 12, md: 18, lg: 16, xl: 10, xxl: 12 }"
                :required="requiredData.companyTelephone"
              >
                <a-form-item ref="telephone" name="companyTelephone">
                  <a-input
                    id="companyTelephone"
                    v-model:value="formData.companyTelephone"
                    data-jwnet-exempt
                    maxlength="13"
                    @input="handlePhoneInput($event, 'company')"
                    @blur="handlePhoneBlur($event, 'company')"
                    :disabled="isDisabledCompanyFields"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="8">
              <InputSlot
                :label="$t('email')"
                inputId="file"
                :labelSpan="{ xs: 24, sm: 6, md: 6, lg: 6, xl: 4, xxl: 4 }"
                :inputSpan="{ xs: 24, sm: 12, md: 18, lg: 16, xl: 15, xxl: 19 }"
                :required="requiredData.companyEmail"
              >
                <a-form-item ref="email" name="companyEmail">
                  <a-input
                    id="companyEmail"
                    v-model:value="formData.companyEmail"
                    data-jwnet-exempt
                    maxlength="254"
                    :disabled="isDisabledCompanyFields"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
          </a-row>
          <InputSlot
            :label="$t('contract_pic')"
            inputId="contractPic"
            :inputSpan="{ xs: 24, sm: 12, md: 9, lg: 8, xl: 5, xxl: 4 }"
            :required="true"
          >
            <a-form-item ref="contractPic" name="contractPic">
              <a-input
                id="contractPic"
                v-model:value="formData.contractPic"
                :data-jwnet-value="formData.contractPic"
                maxlength="16"
                :disabled="isDisabledCompanyFields"
              ></a-input>
            </a-form-item>
          </InputSlot>
        </div>
      </div>
      <div class="box-item">
        <div class="box-inner">
          <div class="box-head">
            <a-row :gutter="{ xs: 8, sm: 16 }">
              <a-col :xs="2" :sm="5" :md="5" :lg="5" :xl="3" :xxl="2">
                <div class="btnLabel text-center">{{ $t('office_infomation') }}</div>
              </a-col>
              <a-col :xs="emailToken ? 24 : 21" :sm="18" :md="18" :lg="17" :xl="18" :xxl="19">
                <div class="flex items-center space-x-5 md:ml-6 mt-1" v-if="emailToken">
                  <a-button
                    class="btn-blue btn-same-company"
                    size="small"
                    htmlType="button"
                    @click="isSameOffice = true"
                    >{{ $t('same_address_as_company') }}</a-button
                  >
                </div>
              </a-col>
              <a-col :xs="emailToken ? 11 : 1" :sm="1" :md="1" :lg="2" :xl="3" :xxl="3">
                <div class="flex justify-end">
                  <a-button @click="addOffice" class="plus-btn office-btn">
                    <span>
                      <plus-circle-filled class="add-icon" />
                    </span>
                    <span>
                      <p class="plus-text">{{ $t('add_office_infomation') }}</p>
                    </span>
                  </a-button>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in formData.offices" :key="index" class="box-item border-blue">
        <div class="box-inner">
          <a-row :gutter="{ xs: 8, sm: 24 }" class="mb-1">
            <a-col :xs="21" :sm="22" :md="22" :lg="22" :xl="23" :xxl="23"> </a-col>
            <a-col :xs="2" :sm="2" :md="2" :lg="2" :xl="1" :xxl="1">
              <a-button
                v-if="formData.offices && formData.offices.length > 1 && item.officeId === -1"
                type="primary"
                danger
                size="small"
                @click="removeOffice(index)"
              >
                <template #icon> <CloseOutlined /> </template>
              </a-button>
            </a-col>
          </a-row>
          <InputSlot
            :label="$t('office')"
            inputId="officeName"
            :inputSpan="{ xs: 24, sm: 14, md: 14, lg: 14, xl: 12, xxl: 8 }"
            :required="item.officeId !== -1 ? false : true"
          >
            <a-form-item
              ref="officeName"
              :name="['offices', index, 'officeName']"
              :rules="rules['offices.officeName']"
            >
              <a-input
                :id="`offices_${index}_officeName`"
                v-model:value="item.officeName"
                :data-jwnet-value="item.officeName"
                :disabled="item.officeId !== -1"
                maxlength="32"
              ></a-input>
            </a-form-item>
          </InputSlot>
          <a-row
            :gutter="{ xs: 8, sm: 16 }"
            :class="{
              'mb-2': formData.offices && formData.offices.length > 1 && item.officeId === -1
            }"
          >
            <a-col :xs="17" :sm="16" :md="12" :lg="12" :xl="8" :xxl="6">
              <InputSlot
                :label="$t('postal_code')"
                inputId="postalCode"
                :labelSpan="{ xs: emailToken ? 15 : 13, sm: 9, md: 6, lg: 8, xl: 9, xxl: 8 }"
                :inputSpan="{ xs: emailToken ? 9 : 11, sm: 12, md: 18, lg: 16, xl: 15, xxl: 16 }"
                :required="item.officeId !== -1 ? false : true"
              >
                <a-form-item
                  ref="postalCode"
                  :name="['offices', index, 'officePostalCode']"
                  :rules="rules['offices.officePostalCode']"
                >
                  <a-input
                    :id="`offices_${index}_officePostalCode`"
                    v-model:value="item.officePostalCode"
                    data-jwnet-exempt
                    :disabled="item.officeId !== -1"
                    maxlength="8"
                    @change="formatPostalCode($event, 'office', index)"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
            <a-col :xs="7" :sm="8" :md="12" :lg="12" :xl="8" :xxl="6">
              <a-button
                type="primary"
                size="small"
                @click="getAddress('office', index)"
                class="btn-search-adr"
                v-if="item.officeId === -1"
                :disabled="
                  (item.officePostalCode && item.officePostalCode.length < 8) ||
                  item.officeId !== -1 ||
                  !item.officePostalCode
                "
              >
                {{ $t('address_search') }}
              </a-button>
            </a-col>
          </a-row>
          <InputSlot
            :label="$t('address')"
            inputId="address"
            :inputSpan="{ xs: 24, sm: 18, md: 21, lg: 20, xl: 21, xxl: 22 }"
            :required="item.officeId !== -1 ? false : true"
          >
            <a-form-item
              ref="address"
              :name="['offices', index, 'officeAddress']"
              :rules="rules['offices.officeAddress']"
            >
              <a-input
                :id="`offices_${index}_officeAddress`"
                v-model:value="item.officeAddress"
                :data-jwnet-value="item.officeAddress"
                :disabled="item.officeId !== -1 || item.shouldDisabled"
                maxlength="254"
              ></a-input>
            </a-form-item>
          </InputSlot>
          <a-row
            :gutter="{ xs: 8, sm: 16 }"
            :class="
              formData.offices && formData.offices.length > 1 && item.officeId === -1 ? 'mb-6' : ''
            "
          >
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="8">
              <InputSlot
                :label="$t('telephone')"
                inputId="telephone"
                :labelSpan="{ xs: 24, sm: 6, md: 6, lg: 8, xl: 6, xxl: 6 }"
                :inputSpan="{ xs: 24, sm: 12, md: 18, lg: 16, xl: 10, xxl: 12 }"
                :required="requiredData.offices.officeTelephone"
              >
                <a-form-item
                  ref="telephone"
                  :name="['offices', index, 'officeTelephone']"
                  :rules="rules['offices.officeTelephone']"
                >
                  <a-input
                    :id="`offices_${index}_officeTelephone`"
                    v-model:value="item.officeTelephone"
                    data-jwnet-exempt
                    maxlength="13"
                    @input="handlePhoneInput($event, 'office', index)"
                    @blur="handlePhoneBlur($event, 'office', index)"
                    :disabled="item.shouldDisabled"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="8">
              <InputSlot
                :label="$t('email')"
                inputId="email"
                :labelSpan="{ xs: 24, sm: 6, md: 6, lg: 6, xl: 4, xxl: 4 }"
                :inputSpan="{ xs: 24, sm: 12, md: 18, lg: 16, xl: 15, xxl: 19 }"
                :required="requiredData.offices.officeEmail"
              >
                <a-form-item
                  ref="email"
                  :name="['offices', index, 'officeEmail']"
                  :rules="rules['offices.officeEmail']"
                >
                  <a-input
                    :id="`offices_${index}_officeEmail`"
                    v-model:value="item.officeEmail"
                    data-jwnet-exempt
                    maxlength="254"
                    :disabled="item.shouldDisabled"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="box-item">
        <div class="box-inner">
          <div class="box-head">
            <a-row :gutter="{ xs: 8, sm: 16 }">
              <a-col :xs="2" :sm="5" :md="5" :lg="5" :xl="3" :xxl="2">
                <div class="btnLabel text-center">{{ $t('info_site_discharge') }}</div>
              </a-col>

              <a-col :xs="emailToken ? 23 : 21" :sm="18" :md="18" :lg="17" :xl="18" :xxl="19">
                <div class="flex items-center space-x-5 md:ml-6 mt-1" v-if="emailToken">
                  <a-button
                    class="btn-blue btn-same-company"
                    size="small"
                    htmlType="button"
                    @click="onClickSameAsCompany"
                    >{{ $t('same_address_as_company') }}</a-button
                  >
                </div>
              </a-col>

              <a-col :xs="emailToken ? 11 : 1" :sm="1" :md="1" :lg="2" :xl="3" :xxl="3">
                <div class="flex justify-end">
                  <a-button @click="addWaste" class="plus-btn waste-btn">
                    <span>
                      <plus-circle-filled class="add-icon" />
                    </span>
                    <span>
                      <p class="plus-text">{{ $t('add_waste_info') }}</p>
                    </span>
                  </a-button>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>

      <div v-for="(item, index) in formData.wastes" :key="index" class="box-item border-blue">
        <div class="box-inner">
          <a-row :gutter="{ xs: 8, sm: 24 }" class="mb-1">
            <a-col :xs="21" :sm="22" :md="22" :lg="22" :xl="23" :xxl="23"> </a-col>
            <a-col :xs="2" :sm="2" :md="2" :lg="2" :xl="1" :xxl="1">
              <a-button
                v-if="formData.wastes && formData.wastes.length > 1 && item.wasteId === -1"
                type="primary"
                danger
                size="small"
                @click="removeWaste(index)"
              >
                <template #icon> <CloseOutlined /> </template>
              </a-button>
            </a-col>
          </a-row>
          <InputSlot
            :label="$t('discharge_sitename')"
            inputId="dischargeSitename"
            :inputSpan="{ xs: 24, sm: 14, md: 14, lg: 14, xl: 12, xxl: 8 }"
            :required="item.wasteId !== -1 ? false : true"
          >
            <a-form-item
              id="dischargeSitename"
              :name="['wastes', index, 'dischargeSitename']"
              :rules="rules['wastes.dischargeSitename']"
            >
              <a-input
                :id="`wastes_${index}_dischargeSitename`"
                v-model:value="item.dischargeSitename"
                :data-jwnet-value="item.dischargeSitename"
                :disabled="item.wasteId !== -1"
                maxlength="32"
              ></a-input>
            </a-form-item>
          </InputSlot>
          <a-row :gutter="{ xs: 8, sm: 16 }">
            <a-col :xs="17" :sm="16" :md="12" :lg="12" :xl="8" :xxl="6">
              <InputSlot
                :label="$t('postal_code')"
                inputId="wastePostalCode"
                :labelSpan="{ xs: emailToken ? 15 : 13, sm: 9, md: 6, lg: 8, xl: 9, xxl: 8 }"
                :inputSpan="{ xs: emailToken ? 9 : 11, sm: 12, md: 18, lg: 16, xl: 15, xxl: 16 }"
                :required="item.wasteId !== -1 ? false : true"
              >
                <a-form-item
                  ref="wastePostalCode"
                  :name="['wastes', index, 'wastePostalCode']"
                  :rules="rules['wastes.wastePostalCode']"
                >
                  <a-input
                    :id="`wastes_${index}_wastePostalCode`"
                    v-model:value="item.wastePostalCode"
                    data-jwnet-exempt
                    :disabled="item.wasteId !== -1"
                    maxlength="8"
                    @change="formatPostalCode($event, 'waste', index)"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
            <a-col :xs="7" :sm="8" :md="12" :lg="12" :xl="8" :xxl="6">
              <a-button
                type="primary"
                size="small"
                @click="getAddress('waste', index)"
                class="btn-search-adr"
                v-if="item.wasteId === -1"
                :disabled="
                  (item.wastePostalCode && item.wastePostalCode.length < 8) ||
                  item.wasteId !== -1 ||
                  !item.wastePostalCode
                "
              >
                {{ $t('address_search') }}
              </a-button>
            </a-col>
          </a-row>
          <InputSlot
            :label="$t('address')"
            inputId="wasteAddress"
            :inputSpan="{ xs: 24, sm: 18, md: 21, lg: 20, xl: 21, xxl: 21 }"
          >
            <a-row :gutter="{ xs: 8, sm: 16 }">
              <a-col :xs="10" :sm="8" :md="8" :lg="7" :xl="4" :xxl="4">
                <a-form-item :name="['wastes', index, 'wasteAddress']">
                  <a-input disabled :value="item.wasteAddress"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xs="10" :sm="8" :md="8" :lg="7" :xl="4" :xxl="4">
                <a-form-item :name="['wastes', index, 'wasteAddress2']">
                  <a-input disabled :value="item.wasteAddress2"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </InputSlot>
          <InputSlot
            :label="$t('')"
            inputId="wasteAddress"
            :inputSpan="{ xs: 24, sm: 18, md: 21, lg: 20, xl: 21, xxl: 22 }"
            :required="item.wasteId !== -1 ? false : true"
          >
            <a-form-item
              ref="wasteAddress"
              :name="['wastes', index, 'wasteAddress3']"
              :rules="rules['wastes.wasteAddress3']"
            >
              <a-input
                :id="`wastes_${index}_wasteAddress`"
                v-model:value="item.wasteAddress3"
                :data-jwnet-value="item.wasteAddress3"
                :disabled="item.wasteId !== -1 || item.shouldDisabled"
                maxlength="80"
              ></a-input>
            </a-form-item>
          </InputSlot>
          <a-row :gutter="{ xs: 8, sm: 16 }">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="8">
              <InputSlot
                :label="$t('telephone')"
                inputId="telephone"
                :labelSpan="{ xs: 24, sm: 6, md: 6, lg: 8, xl: 6, xxl: 6 }"
                :inputSpan="{ xs: 24, sm: 12, md: 18, lg: 16, xl: 10, xxl: 12 }"
                :required="requiredData.wastes.wasteTelephone"
              >
                <a-form-item
                  ref="wasteTelephone"
                  :name="['wastes', index, 'wasteTelephone']"
                  :rules="rules['wastes.wasteTelephone']"
                >
                  <a-input
                    :id="`wastes_${index}_wasteTelephone`"
                    v-model:value="item.wasteTelephone"
                    data-jwnet-exempt
                    maxlength="13"
                    @input="handlePhoneInput($event, 'waste', index)"
                    @blur="handlePhoneBlur($event, 'waste', index)"
                    :disabled="item.shouldDisabled"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :xxl="8">
              <InputSlot
                :label="$t('email')"
                inputId="wasteEmail"
                :labelSpan="{ xs: 24, sm: 6, md: 6, lg: 6, xl: 4, xxl: 4 }"
                :inputSpan="{ xs: 24, sm: 12, md: 18, lg: 16, xl: 15, xxl: 19 }"
                :required="requiredData.wastes.wasteEmail"
              >
                <a-form-item
                  ref="wasteEmail"
                  :name="['wastes', index, 'wasteEmail']"
                  :rules="rules['wastes.wasteEmail']"
                >
                  <a-input
                    :id="`wastes_${index}_wasteEmail`"
                    v-model:value="item.wasteEmail"
                    data-jwnet-exempt
                    maxlength="254"
                    :disabled="item.shouldDisabled"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
          </a-row>
          <InputSlot
            :label="$t('waste_staff')"
            inputId="wasteStaff"
            :inputSpan="{ xs: 24, sm: 12, md: 9, lg: 8, xl: 5, xxl: 4 }"
            :required="requiredData.wastes.wasteStaff"
            :class="
              formData.wastes && formData.wastes.length > 1 && item.wasteId === -1 ? 'mb-6' : ''
            "
          >
            <a-form-item
              ref="wasteStaff"
              :name="['wastes', index, 'wasteStaff']"
              :rules="rules['wastes.wasteStaff']"
            >
              <a-input
                :id="`wastes_${index}_wasteStaff`"
                v-model:value="item.wasteStaff"
                :data-jwnet-value="item.wasteStaff"
                maxlength="24"
                :disabled="item.shouldDisabled && !enableContractPic"
              ></a-input>
            </a-form-item>
          </InputSlot>
        </div>
      </div>

      <div class="box-item">
        <div class="box-inner">
          <div class="box-head">
            <a-row :gutter="{ xs: 8, sm: 2 }">
              <div class="btnLabel text-center">{{ $t('electronic_subcriber_info') }}</div>
              <div class="flex items-center">
                <span class="ml-4">{{ $t('be_sure_to_enter_edi_key') }}</span>
              </div>
            </a-row>
          </div>
        </div>
      </div>
      <div class="box-item border-blue">
        <div class="box-inner">
          <a-row :gutter="{ xs: 8, sm: 16 }">
            <a-col :xs="24" :sm="24" :md="22" :lg="12" :xl="12" :xxl="8">
              <InputSlot
                :label="$t('registrant_number')"
                inputId="registrantNumber"
                :labelSpan="{ xs: 24, sm: 6, md: 4, lg: 8, xl: 6, xxl: 6 }"
                :inputSpan="{ xs: 24, sm: 12, md: 13, lg: 16, xl: 10, xxl: 12 }"
              >
                <a-form-item ref="registrantNumber" name="registrantNumber">
                  <a-input
                    id="registrantNumber"
                    v-model:value="formData.registrantNumber"
                    :data-jwnet-value="formData.registrantNumber"
                    :disabled="registrantNumberLength > 0 && !isLoginByAdmin"
                    maxlength="7"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8" :xxl="7">
              <InputSlot
                :label="$t('edi_confirmation_key')"
                inputId="ediConfirmationKey"
                :required-area-status="false"
                :labelSpan="{ xs: 24, sm: 6, md: 5, lg: 9, xl: 9, xxl: 7 }"
                :inputSpan="{ xs: 24, sm: 12, md: 12, lg: 15, xl: 15, xxl: 14 }"
              >
                <a-form-item ref="ediConfirmationKey" name="ediConfirmationKey">
                  <a-input
                    id="ediConfirmationKey"
                    v-model:value="formData.ediConfirmationKey"
                    :data-jwnet-value="formData.ediConfirmationKey"
                    :disabled="ediConfirmationKeyLength > 0 && !isLoginByAdmin"
                    maxlength="8"
                    :class="emailToken ? 'relative left-1' : ''"
                  ></a-input>
                </a-form-item>
              </InputSlot>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="btn-submit">
        <a-button
          html-type="button"
          :loading="isLoading"
          class="btn-sbt-acc btn-blue"
          :size="largeSize"
          @click="onFinish"
          >{{ !emailToken ? $t('change') : $t('register') }}</a-button
        >
      </div>
      <br v-if="emailToken" />
    </a-form>
  </div>

  <div v-else class="text-xl fixed inset-0 flex items-center justify-center">
    <div class="max-w-lg mx-auto text-center">
      <div class="flex items-center justify-center mb-4">
        <img :src="sadFaceIcon" alt="" class="w-[60%]" />
      </div>
      <div>
        <p class="font-bold text-2xl mb-2">アカウント情報登録のエラー</p>
        <p class="text-xl">トークンが無効か期限切れです</p>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { nextTick, onBeforeMount, onMounted, reactive, ref, watch } from 'vue';
import Logo from '@/components/Logo.vue';
import { useI18n } from 'vue-i18n';
import InputSlot from '@/views/components/InputSlot.vue';
import type { SizeType } from 'ant-design-vue/es/config-provider';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { Modal, Input, message } from 'ant-design-vue';
import {
  createRules,
  requiredData,
  readonlyData,
  type UserRegistrationInfo,
  scrollToField
} from './const.js';
import { useUserStore } from '@/stores/modules/user.js';
import getAddressByPostalCode from '@/services/modules/zipcode.js';
import { useAuthStore, usePDischargesStore, usePOfficeStore } from '@/stores/index.js';
import { useRoute } from 'vue-router';
import { router } from '@/router/index.js';
import sadFaceIcon from '@/assets/images/sad_face_icon.png';
import { PlusCircleFilled } from '@ant-design/icons-vue';
import { jwtDecode } from 'jwt-decode';
import { setApiDisabled } from '@/services/http';
import { formatModalTitle } from '@/utils/modules/message.js';
import { useJwnetValidation } from '@/utils/useJwnetValidation';

const { t } = useI18n();
const userStore = useUserStore();
let rules = reactive(createRules(t, -1));
const formRef = ref();
const { validateBeforeSubmit } = useJwnetValidation(formRef);
const accountNameRef = ref<typeof Input | null>(null);
const largeSize = ref<SizeType>('large');
const isSameOffice = ref(false);
const isSameWaste = ref(false);
const isLoading = ref(false);
const isLoginByAdmin = ref(false);
const route = useRoute();
const authStore = useAuthStore();
const isDisabledCompanyFields = ref(false);
const enableContractPic = ref(false);
let userId = -1;
let emailToken = '';
let hasShowForm = ref(true);

const formData = ref<UserRegistrationInfo>({
  accountName: '',
  companyName: '',
  companyPostalCode: '',
  companyAddress: '',
  companyTelephone: '',
  companyEmail: '',
  contractPic: '',
  offices: [
    {
      officeId: -1,
      officeName: '',
      officePostalCode: '',
      officeAddress: '',
      officeTelephone: '',
      officeEmail: '',
      shouldDisabled: true
    }
  ],
  wastes: [
    {
      wasteId: -1,
      dischargeSitename: '',
      wastePostalCode: '',
      wasteAddress: '',
      wasteAddress2: '',
      wasteAddress3: '',
      wasteTelephone: '',
      wasteEmail: '',
      wasteStaff: '',
      shouldDisabled: true
    }
  ],
  registrantNumber: '',
  ediConfirmationKey: ''
});

let registrantNumberLength = 0;
let ediConfirmationKeyLength = 0;

onBeforeMount(async () => {
  setApiDisabled(false);
  emailToken = route.query.token as string;
  const isRegisterRouteWithoutToken = route.path === '/user-registration';
  const paramPcode = route.query.pcode as string;
  if (paramPcode) {
    formData.value.wastes[0].wastePostalCode =
      paramPcode.slice(0, 3) + '-' + paramPcode.slice(3, 7);
    getAddress('waste', 0);
  }

  if (emailToken) {
    isDisabledCompanyFields.value = true;
    await userStore
      .getUserByEmailToken(emailToken)
      .then(() => {
        if (userStore.userLogin.active) {
          hasShowForm.value = false;
        } else {
          userId = userStore.userLogin.id;
        }
      })
      .catch(() => {
        hasShowForm.value = false;
      });
  } else {
    if (isRegisterRouteWithoutToken) {
      hasShowForm.value = false;
    } else {
      const token = localStorage.getItem('token');
      if (token) {
        const decodedToken = jwtDecode(token) as any;
        rules = createRules(t, decodedToken.userId);
      }
      await userStore.getUserInfo();
      formData.value = userStore.currentUserInfo;
    }
  }
  if (formData.value.wastes && formData.value.wastes.length === 0) {
    addWaste();
  }
  if (formData.value.offices && formData.value.offices.length === 0) {
    addOffice();
  }

  if (formData.value.registrantNumber)
    registrantNumberLength = formData.value.registrantNumber.length;
  if (formData.value.ediConfirmationKey)
    ediConfirmationKeyLength = formData.value.ediConfirmationKey.length;
});

onMounted(() => {
  accountNameRef.value?.focus();
  const token = localStorage.getItem('token');
  if (token) {
    const decodedToken = jwtDecode(token) as any;
    if (decodedToken.adminId) {
      isLoginByAdmin.value = true;
    }
  }
});

const onClickSameAsCompany = () => {
  isSameWaste.value = true;
  enableContractPic.value = true;
};

const clearFields = (type: string, index?: number) => {
  if (type === 'company') {
    formData.value.companyAddress = '';
    formData.value.companyTelephone = '';
    formData.value.companyEmail = '';
    formData.value.contractPic = '';
  } else if (type === 'office' && index !== undefined) {
    formData.value.offices[index].officeAddress = '';
    formData.value.offices[index].officeTelephone = '';
    formData.value.offices[index].officeEmail = '';
  } else if (type === 'waste' && index !== undefined) {
    formData.value.wastes[index].wasteAddress = '';
    formData.value.wastes[index].wasteAddress2 = '';
    formData.value.wastes[index].wasteAddress3 = '';
    formData.value.wastes[index].wasteTelephone = '';
    formData.value.wastes[index].wasteEmail = '';
    formData.value.wastes[index].wasteStaff = '';
  }
};

const handleChangePostalCode = (type: string, index?: number) => {
  if (type === 'company') {
    isDisabledCompanyFields.value = true;
    clearFields('company');
  }

  if (type === 'office' && index !== undefined) {
    formData.value.offices[index].shouldDisabled = true;
    clearFields('office', index);
  }

  if (type === 'waste' && index !== undefined) {
    formData.value.wastes[index].shouldDisabled = true;
    clearFields('waste', index);
  }
};

const formatPostalCode = (event: Event, fieldName: string, index?: number) => {
  handleChangePostalCode(fieldName, index);
  const input = event.target as HTMLInputElement;

  let postalCode = input.value.replace(/\D/g, '');

  if (postalCode.length > 3) {
    postalCode = postalCode.slice(0, 3) + '-' + postalCode.slice(3, 7);
  }

  if (fieldName === 'company') {
    formData.value.companyPostalCode = postalCode;
  } else if (fieldName === 'office' && index !== undefined) {
    formData.value.offices[index].officePostalCode = postalCode;
  } else if (fieldName === 'waste' && index !== undefined) {
    formData.value.wastes[index].wastePostalCode = postalCode;
  }

  input.value = postalCode;
};

import { PhoneService } from '@/utils';
const handlePhoneInput = (event: Event, fieldName: string, index?: number): void => {
  const input = event.target as HTMLInputElement;
  const normalized = PhoneService.normalizePhoneNumber(input.value);
  input.value = normalized;
  if (fieldName === 'company') {
    formData.value.companyTelephone = normalized;
  } else if (fieldName === 'office' && index !== undefined) {
    formData.value.offices[index].officeTelephone = normalized;
  } else if (fieldName === 'waste' && index !== undefined) {
    formData.value.wastes[index].wasteTelephone = normalized;
  }
};

const handlePhoneBlur = (event: Event, fieldName: string, index?: number): void => {
  const input = event.target as HTMLInputElement;
  const { formattedNumber } = PhoneService.formatJapaneseNumber(input.value);
  input.value = formattedNumber;
  if (fieldName === 'company') {
    formData.value.companyTelephone = formattedNumber;
  } else if (fieldName === 'office' && index !== undefined) {
    formData.value.offices[index].officeTelephone = formattedNumber;
  } else if (fieldName === 'waste' && index !== undefined) {
    formData.value.wastes[index].wasteTelephone = formattedNumber;
  }
};

const onFinish = async (values: any) => {
  if (!(await validateBeforeSubmit())) return;
  let modal = Modal.confirm({
    title: '',
    okText: t('cancel_button'),
    okType: 'danger',
    cancelText: t('yes'),
    cancelButtonProps: {
      type: 'primary',
      onClick: async () => {
        try {
          await handleSubmit();
          modal.destroy();
        } catch (error) {
          console.log(error);
        }
      }
    },
    okButtonProps: { onClick: () => modal.destroy() },
    centered: true,
    maskClosable: true
  });
  const title = !emailToken ? t('MSG_00_04_2') : t('MSG_00_04');
  modal.update({
    title: formatModalTitle(title)
  });
};

const handleSubmit = async () => {
  isLoading.value = true;
  try {
    if (emailToken) {
      const token = await userStore.registerUserInfo(formData.value, userId);
      if (token) {
        localStorage.setItem('token', token as string);
        localStorage.setItem('token-lifetime', '0');
        localStorage.setItem('token-starttime', String(Date.now()));
        authStore.token = token as string;
        await authStore.getAuthInfo();
        message.success(t('MSG_05_1'));

        const type = route.query.type as string;
        const size = route.query.size as string;
        const num = Number(route.query.num) || 0;
        const week = Number(route.query.week) || 0;

        if (type && size && num && week) {
          router.push(
            '/new-quote-request/regular-garbage' +
              `?type=${type}&size=${size}&num=${num}&week=${week}`
          );
        } else {
          router.push('/');
        }
      }
    } else {
      await userStore.updateUserInfo(formData.value);
      authStore.refreshToken();
      message.success(t('user_info_updated'));
      router.push('/');
    }
  } catch (error: any) {
    if (emailToken) {
      message.error(t('register_account_failed'));
    } else {
      message.error(t('update_account_failed'));
    }
  } finally {
    isLoading.value = false;
  }
};

const removeWaste = async (index: number) => {
  formData.value.wastes.splice(index, 1);
  const fieldsToClear = [
    'dischargeSitename',
    'wastePostalCode',
    'wasteAddress',
    'wasteAddress2',
    'wasteAddress3',
    'wasteTelephone',
    'wasteEmail',
    'wasteStaff'
  ];

  fieldsToClear.forEach((field) => {
    const namePath = ['wastes', index, field];
    clearValidate(namePath);
  });
};

const removeOffice = async (index: number) => {
  formData.value.offices.splice(index, 1);
  const fieldsToClear = [
    'officeName',
    'officePostalCode',
    'officeAddress',
    'officeTelephone',
    'officeEmail'
  ];

  fieldsToClear.forEach((field) => {
    const namePath = ['offices', index, field];
    clearValidate(namePath);
  });
};

const clearValidate = (namePath: any) => {
  formRef.value.clearValidate([namePath]);
};

const addOffice = () => {
  formData.value.offices.push({
    officeId: -1,
    officeName: '',
    officePostalCode: '',
    officeAddress: '',
    officeTelephone: '',
    officeEmail: '',
    shouldDisabled: true
  });

  nextTick(() => {
    const lastIndex = formData.value.offices.length - 1;
    const fieldId = `offices_${lastIndex}_officeName`;
    scrollToField(fieldId);
  });
};

const addWaste = () => {
  formData.value.wastes.push({
    wasteId: -1,
    dischargeSitename: '',
    wastePostalCode: '',
    wasteAddress: '',
    wasteAddress2: '',
    wasteAddress3: '',
    wasteTelephone: '',
    wasteEmail: '',
    wasteStaff: '',
    shouldDisabled: true
  });

  nextTick(() => {
    const lastIndex = formData.value.wastes.length - 1;
    const fieldId = `wastes_${lastIndex}_dischargeSitename`;
    scrollToField(fieldId);
  });
};

const getAddress = (addressType: string, index?: number) => {
  let postalCode: string | undefined;

  switch (addressType) {
    case 'company':
      postalCode = formData.value.companyPostalCode;
      break;
    case 'office':
      if (index !== undefined) postalCode = formData.value.offices[index]?.officePostalCode;
      break;
    case 'waste':
      if (index !== undefined) postalCode = formData.value.wastes[index]?.wastePostalCode;
      break;
    default:
      console.warn(`Unknown address type: ${addressType}`);
      return;
  }

  if (!postalCode) {
    console.warn(`Postal code for ${addressType} is empty`);
    return;
  }
  const isDischarge = addressType === 'waste';
  getAddressByPostalCode(postalCode, isDischarge)
    .then((address) => {
      switch (addressType) {
        case 'company':
          if (address === '') {
            message.error(t('pos_code_not_found'));
            isDisabledCompanyFields.value = true;
            return;
          }
          isDisabledCompanyFields.value = false;
          formData.value.companyAddress = address;
          formRef.value.validateFields(['companyAddress']);
          break;
        case 'office':
          if (index !== undefined) {
            if (address === '') {
              message.error(t('pos_code_not_found'));
              formData.value.offices[index].shouldDisabled = true;
              return;
            }
            formData.value.offices[index].shouldDisabled = false;
            formData.value.offices[index].officeAddress = address;
            formRef.value.validateFields([['offices', index, 'officeAddress']]);
          }
          break;

        case 'waste':
          if (index !== undefined) {
            if (address === '') {
              message.error(t('pos_code_not_found'));
              formData.value.wastes[index].shouldDisabled = true;
              return;
            }
            formData.value.wastes[index].shouldDisabled = false;
            formData.value.wastes[index].wasteAddress = address[0];
            formData.value.wastes[index].wasteAddress2 = address[1];
            formData.value.wastes[index].wasteAddress3 = address[2];
            formRef.value.validateFields([['wastes', index, 'wasteAddress3']]);
          }
          break;
      }
    })
    .catch((error) => {
      console.error('Error fetching address:', error);
    });
};

const validateFields = (prefix: string, index: number, fields: string[]) => {
  fields.forEach((field) => {
    formRef.value.validateFields([[prefix, index, field]]);
  });
};

watch(
  () => [isSameOffice.value, isSameWaste.value],
  async ([newIsSameOffice, newIsSameWaste]) => {
    const firstOffice = formData.value.offices[0];
    const firstWaste = formData.value.wastes[0];

    if (newIsSameOffice && firstOffice) {
      Object.assign(firstOffice, {
        officeName: formData.value.companyName,
        officePostalCode: formData.value.companyPostalCode,
        officeAddress: formData.value.companyAddress,
        officeTelephone: formData.value.companyTelephone,
        officeEmail: formData.value.companyEmail
      });
      isSameOffice.value = false;
      validateFields('offices', 0, [
        'officeName',
        'officePostalCode',
        'officeAddress',
        'officeTelephone',
        'officeEmail'
      ]);
    }

    if (newIsSameWaste && firstWaste) {
      const addresses = (await getAddressByPostalCode(
        formData.value.companyPostalCode,
        true
      )) as any;
      // Lấy wasteAddress3 từ companyAddress: bỏ phần tỉnh/thành (address[0]) và quận/huyện (address[1])
      // để giữ nguyên ký tự người dùng tự thêm (ví dụ: "銀座555" thay vì chỉ "銀座")
      const prefixToRemove = (addresses[0] || '') + (addresses[1] || '');
      const companyAddr = formData.value.companyAddress || '';
      const wasteAddress3Value = companyAddr.startsWith(prefixToRemove)
        ? companyAddr.slice(prefixToRemove.length)
        : addresses[2];
      Object.assign(firstWaste, {
        dischargeSitename: formData.value.companyName,
        wastePostalCode: formData.value.companyPostalCode,
        wasteAddress: addresses[0],
        wasteAddress2: addresses[1],
        wasteAddress3: wasteAddress3Value,
        wasteTelephone: formData.value.companyTelephone,
        wasteEmail: formData.value.companyEmail
      });
      isSameWaste.value = false;
      validateFields('wastes', 0, [
        'dischargeSitename',
        'wastePostalCode',
        'wasteAddress',
        'wasteAddress2',
        'wasteAddress3',
        'wasteTelephone',
        'wasteEmail'
      ]);
    }
  },
  { immediate: true }
);
</script>
<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/form.scss';

$blue: #2196f3;
.plus-btn {
  padding-left: 0px;
  padding-right: 0px;
  box-shadow: none;

  .add-icon {
    position: absolute;
    top: 6px;
    font-size: 17px;
    color: $blue;
  }

  .plus-text {
    margin: 0px;
    color: $blue;
    margin-left: 22px;
    margin-bottom: 15px;
  }
}

.office-btn {
  @media (max-width: 425px) {
    margin-right: 40px;
  }

  @media (max-width: 375px) {
    margin-right: 23px;
  }
  @media (max-width: 320px) {
    margin-right: 0px;
  }
}

.waste-btn {
  @media (max-width: 425px) {
    margin-right: 26px;
  }

  @media (max-width: 375px) {
    margin-right: 8px;
  }
  @media (max-width: 320px) {
    margin-right: -15px;
  }
}

.btn-same-company {
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.btn-search-adr {
  color: white;
  border: none;
  font-size: 14px;
  border-radius: 5px;
  padding-left: 20px !important;
  padding-right: 20px !important;
  margin-top: 5px;
  @media (max-width: 576px) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

.user-info-container {
  width: 85%;
  margin: 0 auto; /* This will center the container horizontally */
  margin-top: 20px;
}

.btn-sbt-acc {
  min-width: 250px !important;
  margin: 8px;
}
.red-button {
  background-color: $red_color;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  float: right;
}

.red-button:hover {
  background-color: red;
}
.register-title {
  color: $blue_text_color2;
}
</style>
